/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { auth } from "../../../firebase";
import {
    createUserWithEmailAndPassword,
    GoogleAuthProvider,
    sendEmailVerification, signInWithEmailAndPassword,
    signInWithPopup,
    updateProfile,
} from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { CardText, CardTitle, Col, Row } from "reactstrap";
import ButtonComponent from "../../../components/ButtonComponent";
import ControlledTextField from "../../../components/ControlledTextField";
import "./index.css";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import { useCreateAdminUserMutation, useLazyGetCheckAdminUserQuery } from "../../../redux/services/authService";
import UserForm from "../UserDataForm/userDataForm";
import SignUpImage from "../../../assets/images/Image1.PNG";
import Logo from "../../../assets/images/logo.PNG";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";

// const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

type FormData = {
    email: string;
    password: string;
    confirmPassword: string;
    countryCode?: string;
    phoneNumber?: string;
    firstName?: string;
    lastName?: string;
};

const isAliasedEmail = (email: string): boolean => {
    if (email.includes('@gmail.com') || email.includes('@googlemail.com')) {
        const [localPart] = email.split('@');
        return localPart.includes('+');
    }
    return false;
};
const SignUp: React.FC = () => {

    const navigate = useNavigate();

    const { control, handleSubmit, watch } = useForm<FormData>(
        {
            defaultValues: {

            }
        }
    );
    const [createAdminUser] = useCreateAdminUserMutation();

    const [trigger, { data: checkAdminUserData, isLoading, error }] = useLazyGetCheckAdminUserQuery();

    const [showModal, setShowModal] = useState(false);
    const [displayName, setDisplayName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [photoUrl, setPhotoUrl] = useState("");
    const [verificationMessage, setVerificationMessage] = useState("");
    const [userId, setUserId] = useState<string>("");

    const password = watch("password");

    const adminUserCreate = async (adminUserData: any) => {
        try {
            const response = await createAdminUser(adminUserData).unwrap();
            toast.success("Created Admin User Successfully..!");
            navigate("/sign-in");
        } catch (apiError: any) {
            console.error("Error uploading user data to API:", apiError);
            toast.error(apiError);
        }
    };

    const checkUser = async (userId: any) => {
        trigger(userId);
    }

    const signUp = async (
        email: string,
        password: string,
        displayName: string,
        phoneNumber: string
    ) => {
        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            if (userCredential.user) {
                await updateProfile(userCredential.user, { displayName });
                await sendEmailVerification(userCredential.user);
                toast.success("Verification email sent. Please check your mails.");
            }

            const accessToken = await userCredential.user.getIdToken();

            localStorage.setItem("accessToken", accessToken);

            const adminUserData = {
                userId: userCredential.user.uid,
                displayName,
                email,
                phoneNumber,
                photoUrl: userCredential.user?.photoURL ? userCredential.user?.photoURL : '',
            };

            adminUserCreate(adminUserData)

            toast.success("Account Created Successfully! Please verify your email.");
            navigate("/sign-in");
        } catch (error: any) {
            if (error.code === 'auth/email-already-in-use') {
                try {
                    const existingUserCredential = await signInWithEmailAndPassword(auth, email, password);
                    const userId = existingUserCredential.user.uid;
                    setUserId(userId);
                    checkUser(userId);
                } catch (signInError: any) {
                    console.error("Error signing in the existing user:", signInError);
                }
            }
            toast.error(
                error.code ||
                "Something went wrong. Please check your email and password."
            );
        }
    };

    const googleSignUp = async () => {
        const provider = new GoogleAuthProvider();
        provider.setCustomParameters({ prompt: "select_account" });
        try {
            const userCredential = await signInWithPopup(auth, provider);
            const user = userCredential.user;
            await sendEmailVerification(user);
            toast.success("Verification email sent. Please check your inbox.");

            const displayName = user.displayName || "Unknown";
            const email = user.email || "No Email";
            const phoneNumber = user.phoneNumber || "No Phone Number";
            const photoUrl = user.photoURL || "No photo Url";

            const accessToken = await userCredential.user.getIdToken();
            localStorage.setItem("accessToken", accessToken);

            localStorage.setItem("userDisplayName", displayName);
            localStorage.setItem("userEmail", email);
            localStorage.setItem("userPhoneNumber", phoneNumber);
            localStorage.setItem("userPhotoUrl", photoUrl);

            setDisplayName(displayName);
            setEmail(email);
            setPhoneNumber(phoneNumber);
            setPhotoUrl(photoUrl);
            setShowModal(true);
        } catch (error: any) {
            console.error("Error signing in with Google: ", error);
            toast.error(error.message || "Failed to sign in with Google.");
        }
    };

    const onSubmit = (data: FormData) => {
        if (data.password !== data.confirmPassword) {
            toast.error("Your passwords do not match");
            return;
        }
        if (isAliasedEmail(data.email)) {
            toast.error("We don't accept aliasing emails. Please use a regular email.");
            return;
        }
        const displayName = `${data.firstName} ${data.lastName}`;
        signUp(data.email, data.password, displayName, data.phoneNumber || "");

        setPhoneNumber(data.phoneNumber || "")
        setEmail(data.email)
        setDisplayName(displayName)
    };

    const handleModalSubmit = async (formData: {
        displayName?: string;
        email?: string;
        phoneNumber?: string;
    }) => {
        const changes: {
            displayName?: string;
            email?: string;
            phoneNumber?: string;
        } = {};

        if (formData.displayName && formData.displayName !== displayName) {
            changes.displayName = formData.displayName;
        }
        if (formData.email && formData.email !== email) {
            changes.email = formData.email;
        }
        if (formData.phoneNumber && formData.phoneNumber !== phoneNumber) {
            changes.phoneNumber = formData.phoneNumber;
        }

        if (Object.keys(changes).length > 0) {
            try {
                const userId = auth.currentUser?.uid || "";
                const photoUrl = localStorage.getItem("userPhotoUrl") || "";
                const adminUserData = {
                    userId,
                    displayName: changes.displayName || displayName,
                    email: changes.email || email,
                    phoneNumber: changes.phoneNumber || phoneNumber,
                    photoUrl,
                };
                await createAdminUser(adminUserData).unwrap();
                toast.success("Additional Information Saved Successfully!");

                // Check email verification status
                await auth.currentUser?.reload();
                if (auth.currentUser?.emailVerified) {
                    navigate("/sign-in");
                } else {
                    setVerificationMessage(
                        "Please verify your email address to proceed."
                    );
                }
            } catch (apiError: any) {
                console.error("Error uploading additional user data to API:", apiError);
                toast.error("Failed to save additional information.");
            }
        } else {
            handleModalClose();
        }
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    useEffect(() => {
        setDisplayName(localStorage.getItem("userDisplayName") || "");
        setEmail(localStorage.getItem("userEmail") || "");
        setPhoneNumber(localStorage.getItem("userPhoneNumber") || "");
        setPhotoUrl(localStorage.getItem("userPhotoUrl") || "");
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (checkAdminUserData?.adminId === null) {
            const adminUserData = {
                userId: userId,
                displayName,
                email,
                phoneNumber,
                photoUrl: '',
            };

            adminUserCreate(adminUserData)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkAdminUserData]);


    return (
        <div className="signUpBackground">
            <div className="auth-wrapper auth-cover">
                <Row className="auth-inner m-0">
                    <Col
                        className="d-none d-lg-flex align-items-center p-5"
                        lg="7"
                        sm="12"
                    >
                        <div className="w-100 d-lg-flex align-items-center justify-content-center">
                            <img className="img-fluid"
                                src={SignUpImage} alt="Login Cover" />
                        </div>
                    </Col>
                    <Col
                        className="d-flex align-items-center auth-bg px-2 p-lg-5"
                        lg="5"
                        sm="12"
                    >
                        <Col className="px-xl-2 mx-auto" sm="8" md="6" lg="12">
                            <div className="imageAreaBackgroundColor">
                                <img className="mb-2" src={Logo} alt="signupimage" style={{ width: "100%" }} />
                            </div>
                            <CardTitle tag="h2" className="fw-bold mb-1">
                                Welcome to Curry King Admin!
                            </CardTitle>
                            <CardText className="mb-2">
                                Please sign-up to your account and start the adventure
                            </CardText>
                            <Form
                                className="auth-login-form mt-2"
                                onSubmit={handleSubmit(onSubmit)}
                            >
                                <Row>
                                    <Col md="6" className="mb-1">
                                        <ControlledTextField
                                            label="First Name"
                                            inputName="firstName"
                                            inputType="text"
                                            placeholder="Enter Your First Name"
                                            isRequired={false}
                                            control={control}
                                        />
                                    </Col>
                                    <Col md="6" className="mb-1">
                                        <ControlledTextField
                                            label="Last Name"
                                            inputName="lastName"
                                            inputType="text"
                                            placeholder="Enter Your Last Name"
                                            isRequired={false}
                                            control={control}
                                        />
                                    </Col>
                                </Row>
                                <div className="mb-1">
                                    <ControlledTextField
                                        label={"Email"}
                                        inputName={"email"}
                                        inputType={"email"}
                                        placeholder={"Enter Your Email"}
                                        isRequired={true}
                                        control={control}
                                    />
                                </div>
                                <div className="mb-1">
                                    <ControlledTextField
                                        label={"Password"}
                                        inputName={"password"}
                                        isRequired={true}
                                        placeholder={"Enter Password"}
                                        inputType={"password"}
                                        control={control}
                                        rules={{ required: true }}
                                    />
                                </div>
                                <div className="mb-1">
                                    <ControlledTextField
                                        label={"Confirm Password"}
                                        inputName={"confirmPassword"}
                                        isRequired={true}
                                        placeholder={"Confirm Password"}
                                        inputType={"password"}
                                        control={control}
                                        rules={{
                                            required: true,
                                            validate: (value: any) =>
                                                value === password || "Passwords do not match",
                                        }}
                                    />
                                </div>
                                <p>PhoneNumber</p>
                                <div className="mb-1">
                                    <Controller
                                        name="phoneNumber"
                                        control={control}
                                        render={({ field }) => (
                                            <PhoneInput
                                                {...field}
                                                country={"lk"}
                                                inputClass="form-control"
                                                containerClass="mb-1"
                                                inputProps={{
                                                    name: "phoneNumber",
                                                    required: true,
                                                    autoFocus: true,
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                                <Row className="mb-1 mt-3 justify-content-between button-row">
                                    <Col xs="auto" className="button-col">
                                        <ButtonComponent titel={"Sign Up"} type={"submit"} />
                                    </Col>
                                    <Col xs="auto" className="button-col">
                                        <Link to="/sign-in">
                                            <ButtonComponent titel="Sign In" />
                                        </Link>
                                    </Col>
                                </Row>
                                <div className="text-center my-3">
                                    <hr className="my-2" />
                                    <span>or using</span>
                                </div>
                                <div className="d-flex justify-content-center mt-3">
                                    <ButtonComponent
                                        icon={<FontAwesomeIcon icon={faGoogle} />}
                                        titel={"Sign Up with Google"}
                                        type={"button"}
                                        onClick={googleSignUp}
                                    />
                                </div>
                            </Form>
                        </Col>
                    </Col>
                </Row>
            </div>

            <UserForm
                showModal={showModal}
                handleModalClose={handleModalClose}
                handleSubmit={handleModalSubmit}
                displayName={displayName}
                email={email}
                phoneNumber={phoneNumber}
                photoUrl={photoUrl}
                verificationMessage={verificationMessage}
            />
        </div>
    );
};

export default SignUp;
